<template>
  <div>
    <!-- ✅ REENVIAR PARA APROVAÇÃO -->
    <c-q-btn
      v-if="showResendToApproval"
      id="btn-resend-institutional-to-approve"
      propBtnLabel="Reenviar para Aprovação"
      :propBtnFunction="onResendToApprove"
      :propBtnTransparent="false"
      :propBtnSize="EnumButtonSizes.LARGE_1"
    />

    <!-- ✅ REAPROVAÇÃO -->
    <c-q-btn
      v-if="showReapprove"
      id="btn-send-institutional-to-reapprove"
      propBtnLabel="Enviar para Reaprovação"
      :propBtnFunction="onReapprove"
      :propBtnTransparent="false"
      :propBtnSize="EnumButtonSizes.LARGE_1"
    />
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useRouter } from 'vue-router'

import { EnumButtonSizes, EnumRouteNames } from '@/enums/enums'

import { useInstitutionalStore } from '@/stores/institutionalStore'
import { usePagesUtilStore } from '@/stores/pagesUtilStore'
import { useAuthStore } from '@/stores/authStore'

import { CONST_INSTITUTIONAL_STATUS } from '@/static/constantsInstitutional'
import messages from '@/utils/messages'

const institutionalStore = useInstitutionalStore()
const pagesUtilStore = usePagesUtilStore()
const authStore = useAuthStore()
const router = useRouter()
const props = defineProps<{
  accordionRef?: any
}>()

/**
 * ✅ Mostrar botão REENVIAR
 */
const showResendToApproval = computed(() => {
  const status = institutionalStore.institutionalDetail?.status

  return (
    authStore.currentUserCanCreateInstitutional &&
    institutionalStore.institutionalDetail?.cadastroEditado &&
    (institutionalStore.institutionalDetail?.status == CONST_INSTITUTIONAL_STATUS.ADJUSTMENT_REQUESTED.id ||
      institutionalStore.institutionalDetail?.status ==CONST_INSTITUTIONAL_STATUS.ON_EDITING.id)   
  )
})

/**
 * ✅ Mostrar botão REAPROVAR
 */
const showReapprove = computed(() => {
  const status = institutionalStore.institutionalDetail?.status

  return (
    authStore.currentUserCanCreateInstitutional &&
    status === CONST_INSTITUTIONAL_STATUS.ON_REISSUE.id
  )
})

/**
 * ✅ Reenviar para aprovação
 */
/*const onResendToApprove = async () => {
  try {
    pagesUtilStore.showLoading = true

    const detail = institutionalStore.institutionalDetail
    const id = detail?.id
    if (!id) return

    // ✅ prepara imagens — mesmo padrão do sendToApproval
    const imagensParaProcessar = institutionalStore.imagensDraft.length
      ? institutionalStore.imagensDraft
      : (detail?.imagens || []).map(img => ({
          posicaoImagem: img.posicaoImagem,
          urlS3: img.urlS3,
          duracaoImagem: img.duracaoImagem ?? 5,
          file: null
        }))

    const imagensFinais = await institutionalStore.uploadImagens(imagensParaProcessar)

    const telas = institutionalStore.telasDraft.length
      ? institutionalStore.telasDraft
      : (detail?.telasCadastradas || [])

    const exibeTelaAbertura = institutionalStore.exibeTelaAberturaRascunho !== false
      ? institutionalStore.exibeTelaAberturaRascunho
      : detail?.exibeTelaAbertura ?? false

    // ✅ passa os dados processados — igual sendToApproval
    await institutionalStore.resendToApproval(id, imagensFinais, telas, exibeTelaAbertura)

    messages.showSuccessMsg('Cadastro reenviado para aprovação!')

  } catch (error: any) {
    console.error(error)
    messages.showErrorMsg('Erro ao reenviar para aprovação.')
  } finally {
    pagesUtilStore.showLoading = false
  }
}*/

// const onResendToApprove = async () => {
//   try {
//     pagesUtilStore.showLoading = true

//     const detail = institutionalStore.institutionalDetail
//     const id = detail?.id
//     if (!id) return

//     // ✅ prepara imagens
//     const imagensParaProcessar = institutionalStore.imagensDraft.length
//       ? institutionalStore.imagensDraft
//       : (detail?.imagens || []).map(img => ({
//           posicaoImagem: img.posicaoImagem,
//           urlS3: img.urlS3,
//           duracaoImagem: img.duracaoImagem ?? 5,
//           file: null
//         }))

//     // ✅ ✅ 🔥 AJUSTE AQUI
//     let imagensFinais: any[] = []

//     if (imagensParaProcessar && imagensParaProcessar.length > 0) {
//       imagensFinais = await institutionalStore.uploadImagens(imagensParaProcessar)
//     } else {
//       imagensFinais = []
//     }

//     const telas = institutionalStore.telasDraft.length
//       ? institutionalStore.telasDraft
//       : (detail?.telasCadastradas || [])

//     const exibeTelaAbertura = institutionalStore.exibeTelaAberturaRascunho !== false
//       ? institutionalStore.exibeTelaAberturaRascunho
//       : detail?.exibeTelaAbertura ?? false

//     await institutionalStore.resendToApproval(
//       id,
//       imagensFinais,
//       telas,
//       exibeTelaAbertura
//     )

//     institutionalStore.clearReviewData()

//     messages.showSuccessMsg('Cadastro reenviado para aprovação!')

//   } catch (error: any) {
//     console.error(error)
//     messages.showErrorMsg('Erro ao reenviar para aprovação.')
//   } finally {
//     pagesUtilStore.showLoading = false
//   }
// }

const onResendToApprove = async () => {
  try {
    pagesUtilStore.showLoading = true

    const detail = institutionalStore.institutionalDetail
    const id = detail?.id
    if (!id) return

    const imagensParaProcessar = institutionalStore.imagensDraft.length
      ? institutionalStore.imagensDraft
      : (detail?.imagens || []).map((img: any) => ({
          posicaoImagem: img.posicaoImagem,
          urlS3: img.urlS3,
          duracaoImagem: img.duracaoImagem ?? 5,
          file: null
        }))

    let imagensFinais: any[] = []

    if (imagensParaProcessar && imagensParaProcessar.length > 0) {
      imagensFinais = await institutionalStore.uploadImagens(imagensParaProcessar)
    } else {
      imagensFinais = []
    }

    
// ✅ NOVO - pega do accordion
let telasSelecionadas = props.accordionRef?.getTelasSelecionadas()

// ✅ fallback (igual botão anterior)
if (!telasSelecionadas || telasSelecionadas.length === 0) {
  const imagens = institutionalStore.imagensDraft

  const temInicial = imagens.some(img =>
    [1, 2, 3, 4, 8, 9, 10, 11].includes(img.posicaoImagem)
  )

  const temAguarde = imagens.some(img =>
    [6, 7].includes(img.posicaoImagem)
  )

  telasSelecionadas = []
telasSelecionadas.push({ tipoTela: 'ABERTURA' })
  if (temInicial) {
    telasSelecionadas.push({ tipoTela: 'INICIAL' })
  }

  if (temAguarde) {
    telasSelecionadas.push({ tipoTela: 'AGUARDE' })
  }
}

    const telas = institutionalStore.telasDraft.length
      ? institutionalStore.telasDraft
      : (detail?.telasCadastradas || [])

    const exibeTelaAbertura = institutionalStore.exibeTelaAberturaRascunho !== false
      ? institutionalStore.exibeTelaAberturaRascunho
      : detail?.exibeTelaAbertura ?? false

    await institutionalStore.resendToApproval(
      id,
      imagensFinais,
      telasSelecionadas,
      exibeTelaAbertura
    )

    institutionalStore.clearReviewData()

    messages.showSuccessMsg('Cadastro reenviado para aprovação!')

    router.push({
      name: EnumRouteNames.INSTITUTIONAL_VIEW,
      params: { id }
    })
  } catch (error: any) {
    console.error(error)
    messages.showErrorMsg(
      error?.response?.data?.message || 'Erro ao reenviar para aprovação.'
    )
  } finally {
    pagesUtilStore.showLoading = false
  }
};







/*const onReapprove = async () => {
  try {
    pagesUtilStore.showLoading = true

    const detail = institutionalStore.institutionalDetail
    const id = detail?.id
    if (!id) return

    const imagensParaProcessar = institutionalStore.imagensDraft.length
      ? institutionalStore.imagensDraft
      : (detail?.imagens || []).map((img: any) => ({
          posicaoImagem: img.posicaoImagem,
          urlS3: img.urlS3,
          duracaoImagem: img.duracaoImagem ?? 5,
          file: null
        }))

    let imagensFinais: any[] = []

    if (imagensParaProcessar && imagensParaProcessar.length > 0) {
      imagensFinais = await institutionalStore.uploadImagens(imagensParaProcessar)
    } else {
      imagensFinais = []
    }

    
let telasSelecionadas = props.accordionRef?.getTelasSelecionadas()

if (!telasSelecionadas || telasSelecionadas.length === 0) {
  const imagens = institutionalStore.imagensDraft

  const temInicial = imagens.some(img =>
    [1, 2, 3, 4, 8, 9, 10, 11].includes(img.posicaoImagem)
  )

  const temAguarde = imagens.some(img =>
    [6, 7].includes(img.posicaoImagem)
  )

  telasSelecionadas = []
telasSelecionadas.push({ tipoTela: 'ABERTURA' })
  if (temInicial) {
    telasSelecionadas.push({ tipoTela: 'INICIAL' })
  }

  if (temAguarde) {
    telasSelecionadas.push({ tipoTela: 'AGUARDE' })
  }
}


    const telas = institutionalStore.telasDraft.length
      ? institutionalStore.telasDraft
      : (detail?.telasCadastradas || [])

    const exibeTelaAbertura = institutionalStore.exibeTelaAberturaRascunho !== false
      ? institutionalStore.exibeTelaAberturaRascunho
      : detail?.exibeTelaAbertura ?? false

    await institutionalStore.sendToReapproval(
      id,
      imagensFinais,
      telasSelecionadas,
      exibeTelaAbertura
    )

    institutionalStore.clearReviewData()

    messages.showSuccessMsg('Cadastro enviado para reaprovação!')

    router.push({
      name: EnumRouteNames.INSTITUTIONAL_VIEW,
      params: { id }
    })
  } catch (error: any) {
    console.error(error)
    messages.showErrorMsg(
      error?.response?.data?.message || 'Erro ao enviar para reaprovação.'
    )
  } finally {
    pagesUtilStore.showLoading = false
  }
}*/

const onReapprove = async () => {
  try {
    pagesUtilStore.showLoading = true

    const detail = institutionalStore.institutionalDetail
    const id = detail?.id
    if (!id) return

    const imagensParaProcessar = institutionalStore.imagensDraft.length
      ? institutionalStore.imagensDraft
      : (detail?.imagens || []).map((img: any) => ({
          posicaoImagem: img.posicaoImagem,
          urlS3: img.urlS3,
          duracaoImagem: img.duracaoImagem ?? 5,
          file: null
        }))

    let imagensFinais: any[] = []

    if (imagensParaProcessar && imagensParaProcessar.length > 0) {
      imagensFinais = await institutionalStore.uploadImagens(imagensParaProcessar)
    } else {
      imagensFinais = []
    }

    
// ✅ NOVO - pega do accordion
let telasSelecionadas = props.accordionRef?.getTelasSelecionadas()

// ✅ fallback (igual botão anterior)
if (!telasSelecionadas || telasSelecionadas.length === 0) {
  const imagens = institutionalStore.imagensDraft

  const temInicial = imagens.some(img =>
    [1, 2, 3, 4, 8, 9, 10, 11].includes(img.posicaoImagem)
  )

  const temAguarde = imagens.some(img =>
    [6, 7].includes(img.posicaoImagem)
  )

  telasSelecionadas = []
telasSelecionadas.push({ tipoTela: 'ABERTURA' })
  if (temInicial) {
    telasSelecionadas.push({ tipoTela: 'INICIAL' })
  }

  if (temAguarde) {
    telasSelecionadas.push({ tipoTela: 'AGUARDE' })
  }
}

    const telas = institutionalStore.telasDraft.length
      ? institutionalStore.telasDraft
      : (detail?.telasCadastradas || [])

    const exibeTelaAbertura = institutionalStore.exibeTelaAberturaRascunho !== false
      ? institutionalStore.exibeTelaAberturaRascunho
      : detail?.exibeTelaAbertura ?? false

    await institutionalStore.sendToReapproval(
      id,
      imagensFinais,
      telasSelecionadas,
      exibeTelaAbertura
    )

    institutionalStore.clearReviewData()

    messages.showSuccessMsg('Cadastro enviado para reaprovação!')

    router.push({
      name: EnumRouteNames.INSTITUTIONAL_VIEW,
      params: { id }
    })
  } catch (error: any) {
    console.error(error)
    messages.showErrorMsg(
      error?.response?.data?.message || 'Erro ao enviar para reaprovação.'
    )
  } finally {
    pagesUtilStore.showLoading = false
  }
}



</script>

<style scoped>
</style>